<!-- 
	This is the default layout, used in sign-in and sign-up pages.
 -->

<template>
	<div>

		<!-- Default Layout -->
		<a-layout class="layout-default" id="layout-default" :class="[layoutClass]">

			<!-- Layout Header ( Navbar ) -->
			<DefaultHeader class="header_default"></DefaultHeader>
            <div style="height: 64px;"></div>
			<!-- / Layout Header ( Navbar ) -->


			<!-- Page Content -->
			<a-layout-content>
				<router-view />
			</a-layout-content>
			<!-- / Page Content -->

			<!-- Layout Footer -->
            <template v-if="$route.path.indexOf('index') != -1">
                <IndexFooter></IndexFooter>
            </template>
            <template v-else>
                <DefaultFooter></DefaultFooter>
            </template>
			<!-- / Layout Footer -->

		</a-layout>
		<!-- / Default Layout -->

	</div>
</template>

<script>

	import DefaultHeader from '../components/Headers/DefaultHeader' ;
	import DefaultFooter from '../components/Footers/DefaultFooter' ;
    import IndexFooter from '../components/Footers/IndexFooter' ;

	export default ({
		components: {
			DefaultHeader,
			DefaultFooter,
            IndexFooter
		},
		data() {
			return {
			}
		},
		computed: {
			// Sets layout's element's class based on route's meta data.
			layoutClass() {
				return this.$route.meta.layoutClass;
			}
		},
	})

</script>

<style lang="scss">
    /deep/ .layout-default .ant-layout-content {
        padding-top: 0;
    }

    .header_default {
        position: fixed !important;
        top: 0;
        width: 100%;
        z-index: 1;
    }

    .page_banner {
        height: 297px;
        background-image: url('https://static.htpai.com/jy/static/imageenpc/page_banner.png');
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        .content {
            height: 297px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .title {
                font-size: 48px;
                font-weight: bold;
                text-align: center;
                color: #fff;
            }
            .desc {
                font-size: 20px;
                text-align: center;
                color: #CECECE;
            }
        }
    }
</style>